<script lang="ts">
  import buttonsCss from '../../css/v9/buttons.pcss.json'
  import SVG_svelte from "./SVG_svelte.svelte";
  import cn from "classnames";

  export let label: string
  export let value: string | number
  export let status: -1 | 0 | 1
  export let onChange: (value: string | number, add: boolean, exclude: boolean) => void

  let innerStatus = status

  const handlePlus = () => {
    if (innerStatus !== 1) {
      innerStatus = 1
      onChange(value, true, false)
    } else {
      innerStatus = 0
      onChange(value, false, false)
    }
  }

  const handleMinus = () => {
    if (innerStatus !== -1) {
      innerStatus = -1
      onChange(value, true, true)
    } else {
      innerStatus = 0
      onChange(value, false, false)
    }
  }

</script>

<style lang="postcss">
  .container {
    display: flex;
    column-gap: 4px;
  }

  .button {
    --button-width: 24px;
    --button-padding: 0;
    --button-border: 1px solid var(--v9-color-d3-l4);
    --button-fg: var(--v9-color-d3-l4);
    --button-border--hover: 1px solid var(--v9-color-5);
    --button-fg--hover: var(--v9-color-5);
    border-radius: 6px;
  }

  .button--active {
    --button-bg: var(--active-color);
    --button-border: none;
    --button-fg: white;
    --button-fg--hover: white;
    --button-bg--hover: var(--active-color--hover);
    --button-border--hover: none;
  }

  .label {
    margin-left: 4px;
  }
</style>

<div class="container">
  <button
    on:click={handlePlus}
    class={cn(buttonsCss['button'], buttonsCss['button--icon'])}
    class:button={true}
    class:button--active={innerStatus === 1}
    style="--active-color: var(--green); --active-color--hover: var(--green-2)"
  >
    <SVG_svelte i='sg-new/plus' adaptive/>
  </button>
  <button
    on:click={handleMinus}
    class={cn(buttonsCss['button'], buttonsCss['button--icon'])}
    class:button={true}
    class:button--active={innerStatus === -1}
    style="--active-color: var(--brand-red); --active-color--hover: var(--brand-red--hover)"
  >
    <SVG_svelte i='sg-new/minus' adaptive/>
  </button>
  <span class="label">{label}</span>
</div>
